<template>
  <v-card flat class="mb-5">
    <v-card-text class="px-7">
      <template v-if="isBuka">
        <div class="mt-5">
          <h2 class="black--text">
            Rekapitulasi instrumen evaluasi penyelenggaraan IHT
          </h2>
          <template v-for="(rekap, r) in rekaps">
            <div class="container my-2" :key="r">
              <div class="body-1 font-weight-medium mb-2">{{ rekap.label }}</div>
              <v-card outlined>
                <v-card-text>
                  <div v-for="(child, c) in rekap.children" :key="c">
                    <div
                      :class="['info--text body-1 font-weight-medium mb-4', c > 0 ? 'mt-6' : '']"
                      v-html="child.label"
                    ></div>
                    <v-row
                      class="grey--text text--darken-2 body-2"
                      v-for="(kMonevFeedback, idQuestion) in Object.keys(child.questions)"
                      :key="`${r}-${c}-${idQuestion}`"
                    >
                      <v-col v-if="idQuestion !== 0" cols="12" class="pb-0">
                        <v-divider />
                      </v-col>
                      <v-col cols="12" sm="12" md="5" class="my-auto">
                        <v-row no-gutters style="flex-wrap: nowrap">
                          <v-col
                            cols="1"
                            class="flex-grow-0 flex-shrink-1"
                            style="min-width: 15px; max-width: 25px !important;"
                          >
                            {{ idQuestion + 1 }}.
                          </v-col>
                          <v-col cols="11" class="flex-grow-0 flex-shrink-1">
                            {{ child.questions[kMonevFeedback] }}
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="12" sm="12" md="7">
                        <v-row>
                          <v-col v-for="id in 4" :key="`${r}-${c}-${idQuestion}-${id}`">
                            <div :class="['body-2', labels[id]['color']]">{{ labels[id]['text'] }}</div>
                            <div class="body-1">{{ $getDeepObj(feedback, `${kMonevFeedback}.n${id}`) || 0 }}</div>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </div>
                </v-card-text>
              </v-card>
            </div>
          </template>
        </div>
      </template>
      <template v-else>
        <v-row>
          <v-col cols="12" class="text-center">
            <v-icon x-large color="grey" style="font-size: 6rem" class="mb-3">mdi-file-alert</v-icon>
            <h2>Laporan IHT Tidak Tersedia</h2>
            <div class="body-2">
              Hal ini dikarenakan pihak terkait belum mengirimkan laporannya
            </div>
          </v-col>
        </v-row>
      </template>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'IhtRekap',
  props: {
    laporan: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      labels: {
        1: { color: 'red--text', text: 'Sangat Tidak Setuju' },
        2: { color: 'orange--text', text: 'Tidak Setuju' },
        3: { color: 'blue--text', text: 'Setuju' },
        4: { color: 'green--text', text: 'Sangat Setuju' },
      },
      rekaps: [
        {
          label: 'A. Instrumen Umpan Balik Pengajar IHT',
          children: [
            {
              label: 'Persepsi Terkait Metode IHT',
              questions: {
                201: 'Penyampaian materi yang diberikan menarik',
                202: 'Pengajar menguasai materi IHT',
                203: 'Pengajar mampu menyampaikan materi sehingga mudah dipahami.',
                204: 'Pengajar memberikan umpan balik (feedback) yang membantu peserta untuk lebih memahami materi yang diajarkan',
                205: 'Pengajar memberikan kesempatan bertanya dan berdiskusi.',
                206: 'Pengajar melakukan asesmen yang dilakukan oleh pengajar sesuai dengan tujuan IHT',
                207: 'Pengajar memiliki manajemen waktu pembelajaran yang baik',
                208: 'Pengajar mampu menjawab pertanyaan-pertanyaan yang diajukan oleh peserta IHT',
                209: 'Pengajar mampu memberikan motivasi kepada peserta IHT',
              },
            },
          ],
        },
        {
          label: 'B. Instrumen Umpan Balik Proses Penyelenggaraan IHT',
          children: [
            {
              label: 'Persepsi Terkait Metode IHT',
              questions: {
                210: 'Metode yang di gunakan dapat secara efektif meningkatkan pemahaman dan keterampilan.',
                211: 'Secara umum, durasi pelaksanaan IHT mencukupi.',
                212: 'Selama pelaksanaan IHT, terjadi interaksi antar peserta untuk meningkatkan keterampilan dan pengetahuan.',
                213: 'Keterampilan yang diperoleh selama pelaksanaan IHT relevan dengan tugas saya sebagai pelaksana program di satuan pendidikan',
                214: 'Kegiatan praktik dalam pelaksanaan IHT memiliki kesesuaian dengan konsep/teori yang diajarkan.',
                215: 'Teknik penyampaian materi melalui eksplorasi konsep yang dilanjutkan dengan diskusi (pembelajaran alur MERRDEKA) memudahkan saya dalam memahami materi IHT',
              },
            },
            {
              label: 'Perangkat Ajar IHT',
              questions: {
                216: 'Panduan IHT yang diberikan berisi informasi yang dibutuhkan oleh peserta',
                217: 'Modul IHT mudah untuk diakses/diunduh.',
                218: 'Platform pembelajaran IHT membantu saya memahami materi.',
              },
            },
            {
              label: 'Substansi/Materi IHT',
              questions: {
                219: 'Secara umum, materi IHT cukup mudah dipahami',
                220: 'Materi IHT menyiapkan saya dalam meningkatkan kualitas pembelajaran kepada peserta didik',
                221: 'Materi IHT dapat menjawab permasalahan di tingkat satuan pendidikan',
              },
            },
          ],
        },
      ],
    };
  },
  computed: {
    isBuka() {
      return this.laporan.k_verval_psp > 1;
    },

    feedback() {
      let result = {};

      // set feedbacks
      const feedbacks = this.$getDeepObj(this.laporan, 'psp_monev_feedbacks.data') || [];
      let mapFeedbacks = this.$arrToObj(feedbacks, 'k_monev_feedback_psp') || {};
      for (let kMonevFeedback = 201; kMonevFeedback <= 221; kMonevFeedback++) {
        let values = {};
        for (let i = 1; i <= 4; i++) {
          const monevFeedback = mapFeedbacks[kMonevFeedback] || {};
          values[`n${i}`] = monevFeedback[`n${i}`] || 0;
        }

        result[kMonevFeedback] = Object.assign({}, values);
      }

      return result;
    },
  },
};
</script>

<style scoped></style>
